/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { HEADER_VERSIONS } from 'src/components/ZillowNavbar/constants';
import { StaticDomainConfiguration } from 'src/components/ZillowNavbar/page-frame-types/StaticDomainConfiguration';
import { DesktopZillowSearchPageLogo } from './components/DesktopZillowSearchPageLogo';
import { ZillowIcon } from './components/ZillowIcon';

export type ZillowSearchPageProps = {
    isMobileNavOpen: boolean;
    staticDomain: StaticDomainConfiguration;
    version: HEADER_VERSIONS;
};

export const ZillowSearchPageLogo: FunctionComponent<ZillowSearchPageProps> = ({
    isMobileNavOpen,
    staticDomain,
    version,
}) => (
    <>
        <DesktopZillowSearchPageLogo
            isMobileNavOpen={isMobileNavOpen}
            version={version}
            svgFileName="z-logo-default"
            svgName="Zillow logo"
            staticDomain={staticDomain}
        />
        <ZillowIcon isMobileNavOpen={isMobileNavOpen} version={version} staticDomain={staticDomain} />
    </>
);
